import { useTypedParams } from '@sorare/routing';

import { ArenaBoard } from '#src/components/arena/ArenaBoard/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const GameplayPlayBoardsCompetitionPage = () => {
  const { fixture, competition } = useTypedParams<PageParams>();

  return <ArenaBoard fixture={fixture} competition={competition} />;
};

export default GameplayPlayBoardsCompetitionPage;
